import axios from 'axios';
import { downloadFile } from 'services/download-file.service';

const API_URL = '/api/v1/threshold/';
const RECIPIENT_LIST = 'recipients';
const LIMITS = 'limits';
const UPLOAD_RECIPIENT_LIST = 'update-recipients';
const UPLOAD_THRESHOLDS_VALUES = 'update-limits';
const DOWNLOAD_THRESHOLDS_TEMPLATE = 'download-template';

const getRecipientList = () => axios.get(`${API_URL}${RECIPIENT_LIST}`);

const uploadRecipientList = (file) => {
	const formData = new FormData();
	formData.append('csv', file);
	return axios.post(
		`${API_URL}${UPLOAD_RECIPIENT_LIST}`,
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		},
	);
};

const getLimitsValues = () => axios.get(`${API_URL}${LIMITS}`);

const uploadThresholdsValues = (file) => {
	const formData = new FormData();
	formData.append('csv', file);
	return axios.post(
		`${API_URL}${UPLOAD_THRESHOLDS_VALUES}`,
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		},
	);
};

const downloadTemplate = async () => {
	const response = await axios.get(`${API_URL}${DOWNLOAD_THRESHOLDS_TEMPLATE}`);

	downloadFile(response, 'csv', 'Thresholds Template');
};

export {
	getRecipientList,
	uploadRecipientList,
	getLimitsValues,
	uploadThresholdsValues,
	downloadTemplate,
};
